import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { resetSourceCosts } from "@/components/AdminSourceCost";

const KEYS = [["ricarica", "Ricariche internazionali"], ["giftcard", "Gift card"], ["energia", "Luce & Gas"]];

export const SourceCostSettings = ({ pct, onSaved }) => {
  const [values, setValues] = useState(() => Object.fromEntries(KEYS.map(([k]) => [k, pct?.[k] ?? ""])));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/source-costs", Object.fromEntries(KEYS.map(([k]) => [k, values[k] === "" ? null : Number(values[k])])));
      resetSourceCosts(); toast.success("Percentuali di costo salvate"); onSaved();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Salvataggio non riuscito"); }
    finally { setBusy(false); }
  };
  return (
    <Card className="p-4 space-y-3" data-testid="source-cost-settings">
      <div><h2 className="font-head font-semibold">Percentuali di costo</h2><p className="text-xs text-muted-foreground mt-1">Per i servizi in cui il fornitore non comunica il costo: percentuale dell'importo incassato. Lascia vuoto se non vuoi stimarlo.</p></div>
      <div className="grid sm:grid-cols-3 gap-3">
        {KEYS.map(([k, label]) => <label key={k} className="text-sm">{label} (%)<Input type="number" min="0" max="100" step="0.1" className="mt-1" value={values[k]} onChange={(e) => setValues({ ...values, [k]: e.target.value })} data-testid={`source-cost-pct-${k}`} /></label>)}
      </div>
      <Button size="sm" onClick={save} disabled={busy} data-testid="source-cost-save">{busy ? "Salvataggio…" : "Salva percentuali"}</Button>
    </Card>
  );
};
